import React from 'react';
import {Button, Grid, Input, Modal} from 'semantic-ui-react';
import _ from 'lodash'
import {socket} from "../../../lib/socketio";
import {useSelector} from "react-redux";
import {isAuthorized} from "../../../lib/authorization";
import { createUserLog } from '../../../lib/api';

const ControlSchedColumn = ({ index, column, data }) => {

    const [tagdata, settagdata]= React.useState('');
    const [open, setOpen] = React.useState(false);
    const [isValidationError, setIsValidationError] = React.useState(false);
    const user = useSelector(state => state.nav.user);
    const ppid = useSelector(state => state.header.ppid);
    const electronApp = useSelector(state => state.nav.electronApp);
    const [log, setLog]= React.useState('');

    const handleOpen = (id) => setOpen({...open, [id]: true});

    const handleClose = (id) => {
        setIsValidationError(false);
        settagdata('');
        setOpen({...open, [id]:false});
    };

    const handleSubmit = (event, id) => {
        event.preventDefault();
        if(typeof tagdata === 'undefined' || tagdata === ''){
            setOpen({...open, [id]:false});
        }
        else {
            var writedata = [{'tag_id': id, 'tag_value': tagdata}];
            socket.emit('write tag', writedata);
            setOpen({...open, [id]:false});
            if (!electronApp) {
                createUserLog({ log }).catch(console.error);
            }
        }
        settagdata('');
    }

    const handleChange = (event, value, id,  min, max, display_id) => {
        event.preventDefault();
        if(event.target.value < min || event.target.value > max){
            setIsValidationError(true);
        }
        else {
            setIsValidationError(false);
            settagdata(event.target.value);
            if (!electronApp) {
                setLog({
                    user_id: user.id,
                    powerplant_id: ppid,
                    display_id: display_id,
                    datetime: new Date().toISOString(),
                    data: JSON.stringify({ tag_id: [id] }),
                });
            }
        }
    }


   const gridColumn = _.times((1), (i) => (
        Object.keys(column).map(i => (
            column[i][0].tag_display_name.includes('VSD451 KP & Tau Schedule') || column[i][0].tag_display_name.includes('POSITION SCHEDULE')  ?
                <Grid width = '1000px' celled  stackable key = {column[i]} columns = {3} style={styles.grid}>
                <p style = {{textAlign: 'center', color: '#05AC05', fontWeight: 'bold'}}>{column[i][0].tag_display_name}</p>
                <Grid.Row style={styles.row}>
                    {column[i][0].tag_display_name.includes('POSITION SCHEDULE') ?
                        <>
                        <Grid.Column width = '5'></Grid.Column>
                        <Grid.Column width = '5' style={{textAlign: 'center',fontWeight: 'bold'}}>GC</Grid.Column>
                        <Grid.Column width = '5' style={{textAlign: 'center',fontWeight: 'bold'}}>GI</Grid.Column>
                        </>
                        :
                        <> </>
                    }
                    {column[i].map(r =>
                        <Grid.Column  width = '5' style={{color: '#04BFBF', fontWeight: 'bold', padding:'5px 10px'}}>
                            <Button
                                key = 'button'
                                type = 'button'
                                size='tiny'
                                disabled={electronApp ? false : !isAuthorized(user.hmi_role, r.hmi_security)}
                                content = {data[r.id]}
                                onClick ={  () => {setOpen({...open, [r.id]:true})}}/>
                            <Modal
                                   key = {r.id}
                                   style = {styles.width}
                                   open = {open[r.id]}
                                   onClose={handleClose[r.id]}
                                   onOpen ={handleOpen[r.id]}>
                                <Modal.Header>Enter Value for {r.name}</Modal.Header>
                                <Modal.Content>
                                    <form autoComplete='off' onSubmit={(event, value) => handleSubmit(event, r.id)}>
                                        <Input focus placeholder='Value' style={styles.input}
                                               name='Input change'
                                               label = {r.unit || ""}
                                               labelPosition='right'
                                               type='number'
                                               step ='0.0001'
                                               size='small'
                                               autoFocus
                                               min ={r.min}
                                               max ={r.max}
                                               error={isValidationError}
                                               onChange={(event, value) => handleChange(event, value, r.id,  r.min, r.max, r.r.display_id)}
                                               defaultValue={data[r.id]}
                                        /> {r.unit}
                                     </form>
                                </Modal.Content>
                                <Modal.Actions>
                                    <Button color='blue' content={'Ok'}  disabled={isValidationError}  onClick={(event, value) => handleSubmit(event,  r.id)}/>
                                    <Button
                                        key = 'button'
                                        content = 'Close'
                                        color = 'red'
                                        style={{marginLeft: '5px', marginTop: '10px'}}
                                        onClick ={  () => handleClose(r.id)}/>
                                </Modal.Actions>
                            </Modal> {r.unit}
                        </Grid.Column>
                    )}
                </Grid.Row>
            </Grid>
                :
                column[i][0].tag_display_name === 'CL140ALT SCHEDULES'  ?
                    <Grid width ='30px' celled stackable key = {column[i]} columns={1} style={styles.grid}>
                        <p style={{color: '#05AC05', fontWeight: 'bold'}}>{column[i][0].tag_display_subgroup}</p>
                        <Grid.Row style={styles.row}>
                            {column[i].map(r =>
                                <Grid.Column width ='10' style = {styles.sched}>
                                    <Button
                                        key = 'button'
                                        type = 'button'
                                        size='tiny'
                                        disabled={electronApp ? false : !isAuthorized(user.hmi_role, r.hmi_security)}
                                        content = {data[r.id]}
                                        onClick ={  () => {setOpen({...open, [r.id]:true})}}/>
                                    <Modal
                                        key = {r.id}
                                        style = {styles.width}
                                        open = {open[r.id]}
                                        onClose={handleClose[r.id]}
                                        onOpen ={handleOpen[r.id]}>
                                        <Modal.Header>Enter Value for {r.name}</Modal.Header>
                                        <Modal.Content>
                                            <form autoComplete='off' onSubmit={(event, value) => handleSubmit(event, r.id)}>
                                                <Input focus placeholder='Value' style={styles.input}
                                                       name='Input change'
                                                       label = {r.unit || ""}
                                                       labelPosition='right'
                                                       type='number'
                                                       step ='0.0001'
                                                       size='small'
                                                       autoFocus
                                                       min ={r.min}
                                                       max ={r.max}
                                                       error={isValidationError}
                                                       onChange={(event, value) => handleChange(event, value, r.id, r.min, r.max, r.display_id)}
                                                       defaultValue={data[r.id]}
                                                /> {r.unit}
                                          </form>
                                        </Modal.Content>
                                        <Modal.Actions>
                                            <Button color='blue' content={'Ok'}  disabled={isValidationError}  onClick={(event, value) => handleSubmit(event,  r.id)}/>
                                            <Button
                                                key = 'button'
                                                content = 'Close'
                                                color = 'red'
                                                style={{marginLeft: '5px', marginTop: '10px'}}
                                                onClick ={  () => handleClose(r.id)}/>
                                        </Modal.Actions>
                                    </Modal> {r.unit}
                                </Grid.Column>
                            )}
                        </Grid.Row>
                    </Grid>
                :
                <Grid  width ='500px' key = {column[i]} columns={2} celled stackable style={styles.grid}>
                    <p style={{color: '#05AC05', fontWeight: 'bold'}}>{column[i][0].tag_display_name}</p>
                    <Grid.Row style={styles.row}>
                        {column[i].map(r =>
                            r.name === 'FCV500_LOWLIMSCHNG_6POS' ?
                                <>
                                </>
                            :
                            <Grid.Column width = '8' style={{color: '#04BFBF', fontWeight: 'bold', padding: '5px 10px'}}>
                                <Button
                                    key = 'button'
                                    type = 'button'
                                    size='tiny'
                                    disabled={electronApp ? false : !isAuthorized(user.hmi_role, r.hmi_security)}
                                    content = {data[r.id]}
                                    onClick ={  () => {setOpen({...open, [r.id]:true})}}/>
                                <Modal
                                    key = {r.id}
                                    style = {styles.width}
                                    open = {open[r.id]}
                                    onClose={handleClose[r.id]}
                                    onOpen ={handleOpen[r.id]}>
                                    <Modal.Header>Enter Value for {r.name}</Modal.Header>
                                    <Modal.Content>
                                        <form autoComplete='off' onSubmit={(event, value) => handleSubmit(event, r.id)}>
                                            <Input focus placeholder='Value' style={styles.input}
                                                   name='Input change'
                                                   label = {r.unit || ""}
                                                   labelPosition='right'
                                                   type='number'
                                                   step ='0.0001'
                                                   size='small'
                                                   autoFocus
                                                   min ={r.min}
                                                   max ={r.max}
                                                   error={isValidationError}
                                                   onChange={(event, value) => handleChange(event, value, r.id, r.min, r.max, r.display_id)}
                                                   defaultValue={data[r.id]}
                                            />
                                       </form>
                                    </Modal.Content>
                                    <Modal.Actions>
                                        <Button color='blue' content={'Ok'} disabled={isValidationError} onClick={(event, value) => handleSubmit(event, r.id)}/>
                                        <Button
                                            key = 'button'
                                            content = 'Close'
                                            color = 'red'
                                            style={{marginLeft: '5px', marginTop: '10px'}}
                                            onClick ={  () => handleClose(r.id)}/>
                                    </Modal.Actions>
                                </Modal> {r.unit}
                            </Grid.Column>
                        )}
                    </Grid.Row>
                </Grid>
            ))
    ))

    return (
        <Grid.Column style={{ maxWidth: '400px', padding: '10' }}>
                    {gridColumn}
        </Grid.Column>
    );
};

const styles = {
    grid: {
        // margin: '0'
        marginBottom: '3%'
    },
    row: {
        marginBottom: '3%'
    },
    name: {
        color: 'yellow',
        padding: '2px 0',
        marginBottom: '3%',
        marginRight: '3%',
        marginLeft: '10px'
    },
    header: {
        marginBottom: '15px',
        textAlign: 'center'
    },
    metadata: {
        maxWidth: '300px'
        },
    width: {
        maxWidth: '400px'
    },
    column: {
        margetLeft: '10px'
    },
    sched: {
        // paddingBottom: '0',
        padding: '5px 10px',
        color: '#04BFBF',
        fontWeight: 'bold'
    }
};

export default React.memo(ControlSchedColumn);

